export default import.meta.ROLLUP_FILE_URL_Bu$Igw_7AVO2cewv3Xfqbg;